import sectors from './bucharestSectors.data.js';

const ringContains = (ring: Array<[number, number]>, longitude: number, latitude: number): boolean => {
    let inside = false;
    let previous = ring.length - 1;
    for (let index = 0; index < ring.length; index += 1) {
        const [currentLongitude, currentLatitude] = ring[index];
        const [previousLongitude, previousLatitude] = ring[previous];
        const crossesLatitude = (currentLatitude > latitude) !== (previousLatitude > latitude);
        const intersection = (previousLongitude - currentLongitude) * (latitude - currentLatitude)
            / (previousLatitude - currentLatitude) + currentLongitude;
        if (crossesLatitude && longitude < intersection) {
            inside = !inside;
        }
        previous = index;
    }
    return inside;
};

export const bucharestSectorFromPostcode = (postcode?: string): string => {
    const match = /^0([1-6])\d{4}$/.exec((postcode || '').replace(/\s/g, ''));
    return match ? `Sector ${match[1]}` : '';
};

export const bucharestSectorAt = (longitude?: number, latitude?: number): string => {
    if (typeof longitude !== 'number' || typeof latitude !== 'number') {
        return '';
    }
    const matches = sectors.filter((sector) => ringContains(sector.ring, longitude, latitude));
    return matches.length === 1 ? matches[0].name : '';
};
